"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const applicators_1 = require("./applicators");
/* APPLICATOR */
// Optimized "apply" trap executor, with custom comparators for expensive mutating method
const Applicator = {
    get(constructor, method) {
        const applicators = applicators_1.default[constructor.name];
        return applicators ? applicators[method.name] || applicators_1.default.fallback : applicators_1.default.fallback;
    },
    execute(method, thisArg, thisArgTarget, args) {
        const applicator = Applicator.get(thisArgTarget.constructor, method);
        return applicator(method, thisArg, thisArgTarget, args);
    }
};
/* EXPORT */
exports.default = Applicator;
